import { RootStateOrAny, useDispatch, useSelector } from "react-redux";
import { setShowContainerPoints, setShowReceptionPlacePoints, setShowInternalStorePoints, toggleStoreMapPanel, isEditContainerForm, toggleStoreMapSettingsPanel, setShowContainerCriticalBatteryPoints, setShowContainerLowBatteryPoints, setShowAttachedContainersOnly, setHighlightSilentContainers } from "../../../config/redux/storeMap/StoreMapActions";
import { useTranslation } from 'react-i18next';

export const useStoreMapCommandBar = () => {
    const { t } = useTranslation("admin");
    const dispatch = useDispatch();
    const isSuperAdmin = sessionStorage.getItem('isSuperAdmin') === '1';
    const {
        showReceptionPlacePoints,
        showContainerPoints,
        showContainerCriticalBatteryPoints,
        showContainerLowBatteryPoints,
        showInternalStorePoints,
        showAttachedContainersOnly,
        highlightSilentContainers,
        selectedContainer
    } = useSelector((state: RootStateOrAny) => state.storeMap);

    const editContainer = () => {
        dispatch(toggleStoreMapPanel({ isOpen: true }));
        dispatch(isEditContainerForm(true));
    }

    const showContainer = () => {
        dispatch(toggleStoreMapPanel({ isOpen: true }));
        dispatch(isEditContainerForm(false));
    }

    const showSettingsPanel = () => {
        dispatch(toggleStoreMapSettingsPanel({ isOpen: true }));
    }

    const generateItems = () => {
        const receptionPlaceButton =
            [{
                key: "unhideReceptionPlacePoints",
                text: showReceptionPlacePoints == false ? t("storeMap.commands.showReceptionPlaces") : t("storeMap.commands.hideReceptionPlaces"),
                iconProps: { iconName: "reportdocument" },
                name: "prepare",
                onClick: () => { dispatch(setShowReceptionPlacePoints(!showReceptionPlacePoints)) },
            }]

        const silentButton = isSuperAdmin ? [{
            key: "containerSilentButton",
            text: highlightSilentContainers ? t("storeMap.commands.unmarkSilent") : t("storeMap.commands.markSilent"),
            iconProps: { iconName: highlightSilentContainers ? "LocationDot" : "PlugDisconnected" },
            name: "containerSilentButton",
            onClick: () => { dispatch(setHighlightSilentContainers(!highlightSilentContainers)) }
        }] : [];

        const containerSubButtons =
            [
            ...silentButton,
            {
                key: "containerInactiveButton",
                text: showAttachedContainersOnly ? t("storeMap.commands.allContainers") : t("storeMap.commands.attachedOnly"),
                iconProps: { iconName: showAttachedContainersOnly ? "ViewAll" : "Filter" },
                name: "containerInactiveButton",
                onClick: () => { dispatch(setShowAttachedContainersOnly(!showAttachedContainersOnly)) }
            },
            {
                key: "containerRestBatteryButton",
                text: showContainerPoints == false ? t("storeMap.commands.showContainersOptimal") : t("storeMap.commands.hideContainersOptimal"),
                iconProps: { iconName: "Accept" },
                name: "containerRestBatteryButton",
                onClick: () => { dispatch(setShowContainerPoints(!showContainerPoints)) }
            },
            {
                key: "containerLowBatteryButton",
                text: showContainerLowBatteryPoints == false ? t("storeMap.commands.showContainersLow") : t("storeMap.commands.hideContainersLow"),
                iconProps: { iconName: "Warning" },
                name: "containerLowBatteryButton",
                onClick: () => { dispatch(setShowContainerLowBatteryPoints(!showContainerLowBatteryPoints)) }
            },
            {
                key: "containerCriticalBatteryButton",
                text: showContainerCriticalBatteryPoints == false ? t("storeMap.commands.showContainersCritical") : t("storeMap.commands.hideContainersCritical"),
                iconProps: { iconName: "Error" },
                name: "containerCriticalBatteryButton",
                onClick: () => { dispatch(setShowContainerCriticalBatteryPoints(!showContainerCriticalBatteryPoints)) }
            }]

        const containerButton =
            [{
                key: "unhideContainerPoints",
                text: t("nav.containersList"),
                iconProps: { iconName: "reportdocument" },
                name: "prepare",
                subMenuProps: {
                    items: [
                        ...containerSubButtons,
                    ],
                }
            }]

        const internalStoreButton =
            [{
                key: "unhideInternalStorePoints",
                text: showInternalStorePoints == false ? t("storeMap.commands.showInternalStores") : t("storeMap.commands.hideInternalStores"),
                iconProps: { iconName: "reportdocument" },
                name: "prepare",
                onClick: () => { dispatch(setShowInternalStorePoints(!showInternalStorePoints)) }
            }];

        const editContainerButton = selectedContainer != undefined ?
            [{
                key: "showContainer",
                text: t("storeMap.commands.showContainer"),
                iconProps: { iconName: "reportdocument" },
                name: "show",
                onClick: showContainer,
            },
            {
                key: "editContainer",
                text: t("storeMap.commands.editContainer"),
                iconProps: { iconName: "edit" },
                name: "edit",
                onClick: editContainer,
            }] : []

        const storeMapSettings = [{
            key: "storeMapSettings",
            text: t("nav.settings"),
            iconProps: { iconName: "Settings" },
            name: "storeMapSettings",
            onClick: showSettingsPanel,
        }]

        return [
            ...containerButton,
            ...receptionPlaceButton,
            ...internalStoreButton,
            ...storeMapSettings,
            ...editContainerButton,
        ]
    };

    const items = generateItems()

    return {
        items
    }
};